<div class="category-card">
  <div class="standalone-category-header">
    <wm-common-text class="head-title" [data]="{ text: 'Notes' }"></wm-common-text>
  </div>
  <app-common-notes
    [applicationId]="applicationId"
    [applicationNumber]="applicationNumber">
  </app-common-notes>
</div>